<template>
  <div class="wrapper">
    <Header name="Paramètres organisation" />
    <TabsNavigation
      :tabs="tabsTitle"
      @changeTab="(value) => (state.currentTab = value)"
    />
    <transition mode="out-in" name="fade">
      <component :is="tabsContent[state.currentTab]" />
    </transition>
  </div>
</template>

<script setup>
import { reactive, computed } from "vue";
import { useUserStore } from "@/stores/user.js";
import Header from "@/components/Header.vue";
import History from "./partials/History.vue";
import Members from "./partials/Members.vue";
import Informations from "./partials/Informations.vue";
import Archives from "./partials/Archives.vue";

const userStore = useUserStore();

const tabsTitle = computed(() => {
  const array = [];

  if (userStore.hasPermission("members", 1)) {
    array.push("Gestion des utilisateurs");
  }

  if (userStore.hasPermission("billingHistory", 1)) {
    array.push("Historique des transactions");
    array.unshift("Informations de l'organisation");
  }

  if (userStore.hasPermission("members", 1)) {
    array.push("Campagnes archivées");
  }

  return array;
});

const tabsContent = [Informations, Members, History, Archives];

const state = reactive({
  currentTab: 0,
});
</script>
